// IMPORT COMPONENTS
import BaseModal from '@core/components/modals/base-modal/base-modal';
import $ from 'jquery';

export default class VideoModal extends BaseModal {

  init(id) {
    super.init(id);
    const $content = $('.video-modal__content', $(this.currentModal));
    this.$iframeWrapper = $('.embed-responsive', $content);
    this.videoTitle = $content.data('title');
    this.videoId = $content.data('videoid');
    //this.$iframeWrapper.append(this.getIframe());
  }

  open() {
    super.open();
    this.$iframeWrapper.append(this.getIframe());
  }

  close() {
    super.close();
    this.$iframeWrapper.empty();
  }

  getIframe() {
    return `
    <iframe class="embed-responsive-item video-modal__iframe" title="${this.videoTitle}" src="https://www.youtube.com/embed/${this.videoId}?autoplay=1" frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen>
    </iframe>`
  }
}
